import React from 'react';
import { Input } from 'reactstrap';
import { useIntl } from 'react-intl';

const ChatInput = ({ value, onChange, onKeyPress, disabled, isLatestConversation, chat }) => {
    const intl = useIntl();

    return (
        <>
            {!isLatestConversation && chat?.channel === 'WhatsApp' ? (
                <Input
                    type="text"
                    value={value}
                    onChange={onChange}
                    onKeyPress={onKeyPress}
                    disabled={disabled}
                    autoComplete="off"
                    placeholder={intl.formatMessage({ id: 'dashboard.whatsapp_message' })}
                    title={intl.formatMessage({ id: 'dashboard.whatsapp_reply_window' })}
                />

            ) : (
                <Input
                    type="text"
                    value={value}
                    onChange={onChange}
                    placeholder={intl.formatMessage({ id: 'dashboard.whatsapp_message' })}
                    autoComplete={'off'}
                    onKeyPress={onKeyPress}
                />
            )
            }

        </>
    );
};

export default ChatInput;
